import React from 'react';
import PropTypes from 'prop-types';
import path from 'path';
import Tab from './Tab';
import styles from './Navigation.module.css';
import { useAnalytics } from 'hooks/useAnalytics';
import { reportEndpoints } from './reportDetails';

const propTypes = {
  availableTabs: PropTypes.array.isRequired,
  locationPathName: PropTypes.string.isRequired,
};

function TabContainer({ availableTabs, locationPathName }) {
  const selectedTabEndpoint = path.basename(locationPathName);
  useAnalytics('rlp-header', 'change-tab', selectedTabEndpoint, selectedTabEndpoint);

  const renderTab = (availableTab, selectedTabEndpoint) => {
    return (
      <Tab
        key={availableTab.urlEndPoint}
        urlEndPoint={availableTab.urlEndPoint}
        displayText={availableTab.displayText}
        selectedTabEndpoint={selectedTabEndpoint}
      />
    );
  };

  const { tabList, selectedTabPosition } = availableTabs.reduce(
    (results, tab, index) => {
      results.tabList.push(renderTab(tab, selectedTabEndpoint));
      const selectedIndex = tab.urlEndPoint === selectedTabEndpoint ? index : results.selectedTabPosition;
      return { tabList: results.tabList, selectedTabPosition: selectedIndex };
    },
    { tabList: [], selectedTabPosition: reportEndpoints.includes(selectedTabEndpoint) ? -2 : -1 }
  );

  const highlightPosition = { '--selected-tab-position': selectedTabPosition };

  return (
    <>
      <nav data-testid="tab-navigation" className={styles['tabs-navigation']} role="tablist" style={highlightPosition}>
        {tabList}
      </nav>
    </>
  );
}

TabContainer.propTypes = propTypes;

export default TabContainer;
